import React from 'react'
import Footer from '../components/footer';
import Header from '../components/header';
import Shop from '../components/shop';


const ShopPage = () => {
  return (
    <div>
      {<Header/>}
      {<Shop/>}
      {<Footer/>}
    </div>
  )
}

export default ShopPage
